import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { TreatmentCard } from "@/components/TreatmentCard";
import { CtaButton } from "@/components/CtaButton";
import { GhlEmbedPlaceholder } from "@/components/GhlEmbedPlaceholder";
import { SITE } from "@/constants/testIds";

export default function TreatmentsPage() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.treatments().then(setItems).catch(() => {});
    }, []);

    return (
        <div>
            <PageHeader
                eyebrow="OFFERINGS"
                title="Treatments & Therapies"
                subtitle="Classical Ayurvedic bodywork, cleansing protocols, and consultations — each adapted to your unique constitution."
                breadcrumbs={[{ label: "Home", to: "/" }, { label: "Treatments" }]}
            >
                <div className="flex flex-wrap items-center gap-3">
                    <CtaButton to="/contact">Schedule consultation</CtaButton>
                    <CtaButton to="/packages" variant="secondary" icon={false}>
                        See packages
                    </CtaButton>
                </div>
            </PageHeader>

            <section className="py-12 sm:py-16">
                <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                    <div
                        data-testid={SITE.treatmentsGrid}
                        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6"
                    >
                        {items.map((t) => (
                            <TreatmentCard key={t.slug} t={t} />
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-12 sand-wash bg-grain">
                <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
                        <div className="lg:col-span-5">
                            <h3 className="font-display text-2xl text-moss">
                                Not sure where to begin?
                            </h3>
                            <p className="mt-2 text-foreground/75">
                                Most people start with a 2-hour Initial Consultation. Riley will recommend the right treatment plan based on your specific goals.
                            </p>
                        </div>
                        <div className="lg:col-span-7">
                            <GhlEmbedPlaceholder kind="consultation-form" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
